export const GET_REFRESH_TOKEN_REQUEST_ACCOUNT = 'GET_REFRESH_TOKEN_REQUEST_ACCOUNT';
export const GET_REFRESH_TOKEN_REQUEST_ERROR_ACCOUNT = 'GET_REFRESH_TOKEN_REQUEST_ERROR_ACCOUNT';
export const GET_REFRESH_TOKEN_REQUEST_SUCCESS_ACCOUNT =
    'GET_REFRESH_TOKEN_REQUEST_SUCCESS_ACCOUNT';
